// tslint:disable:no-console
import React from 'react';
import { ButtonFilled } from '../ui';
import { Link } from '@reach/router';
import redirect from '../../lib/redirect';

interface ErrorProps {
  error?: string;
}

class ErrorScreen extends React.Component<ErrorProps, {}> {
  public componentDidMount() {
    const { error } = this.props;
    console.log(error);
  }

  public render() {
    return (
      <div className="bg-white absolute absolute--fill flex items-center justify-center transition">
        <div className="tc">
          <p className="f3 f2-ns display navy mv0">Oh no.</p>
          <p className="navy serif mt2 mb4 measure-narrow lh-copy">
            Something has gone wrong. We&rsquo;d love to know what happened so we can fix it.
          </p>

          <ButtonFilled
            onClick={() => {
              redirect('/notebook');
              window.location.reload();
            }}
          >
            Continue
          </ButtonFilled>

          <div className="mv3">
            <a href="mailto:support@quala.io?subject=Bug Report" className="dib blue hover-navy f6">
              Report Bug
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorScreen;
